type EnterpriseRouteName =
  | 'purchase-data'
  | 'insights'
  | 'venues'
  | 'access'
  | 'reporting'
  | 'historical-venue-availability';

export function getEnterpriseRoute(routeName: EnterpriseRouteName, enterpriseId: string) {
  const prefixUrl = `/enterprise/${enterpriseId}`;
  switch (routeName) {
    case 'purchase-data':
      return `${prefixUrl}/purchase-data`;
    case 'insights':
      return `${prefixUrl}/insights`;
    case 'venues':
      return `${prefixUrl}/venues`;
    case 'reporting':
      return `${prefixUrl}/reporting`;
    case 'access':
      return `${prefixUrl}/access`;
    case 'historical-venue-availability':
      return `${prefixUrl}/venues/historical-venue-availability`;
  }
}
